import React from "react";
import Router from "../src/Router";
function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
